import Vue from 'vue'
import router from './router'
import store from './store'
import Const from 'utils/const'
import App from './App'
import VueMeta from 'vue-meta'
import Rollbar from 'vue-rollbar'
import i18n from './locales'
import { access } from 'utils/access'
import Swal from '../src/assets/old_resources/bower_components/sweetalert2/src/sweetalert2.js'
import Vddl from 'vddl'
import { downloadCompanyEnvironment, downloadManager } from 'utils/download'
import { LOCALE_GET } from 'actions/localization'
import MathJs from 'plugins/math'

import '@/core/plugins/bootstrap-datepicker.en'
import '@/core/plugins/bootstrap-datepicker.ru'
import '@/core/plugins/bootstrap-table'
import { REQUEST_PERMISSIONS, USER_REQUEST } from 'actions/user'

Vue.use(Vddl)
Vue.use(MathJs)

Vue.config.productionTip = false

Vue.prototype.Const = Const

Vue.use(VueMeta)
Vue.use(access)
Vue.use(Rollbar, {
	accessToken: process.env.VUE_APP_NODE_ROLLBAR_KEY,
	captureUncaught: true,
	captureUnhandledRejections: true,
	enabled: process.env.VUE_APP_NODE_ROLLBAR,
	source_map_enabled: true,
	environment: process.env.VUE_APP_NODE_ENV,
	payload: {
		client: {
			javascript: {
				code_version: '1.0'
			}
		}
	}
})

window.urlContext = process.env.VUE_APP_NODE_API_URL + '/'
window.Swal = Swal
window.localizedMessages = {}
window.ClientSessionManager
window.locale = store.getters.getLocale
window.downloadManager = downloadManager
window.downloadCompanyEnvironment = downloadCompanyEnvironment
if (typeof InstallTrigger !== 'undefined') {
	window.browser = 'firefox'
}
if (/*@cc_on!@*/false || !!document.documentMode) {
	window.browser = 'ie'
}

function main () {
	return new Vue({
		el: '#app',
		render: h => h(App),
		router,
		store,
		i18n
	})
}

store.dispatch(LOCALE_GET)
	.then(() => {
		if (store.getters.isAuthenticated) {
			store.dispatch(USER_REQUEST)
				.then(() => {
					store.dispatch(REQUEST_PERMISSIONS).then(() => {
						main()
					})
				})
		} else {
			main()
		}
	})
	.catch(error => {
		console.log(error)
		Vue.rollbar.error(error)
	})

